// extracted by mini-css-extract-plugin
export default {"header":"Header_Resume_header__59pkQ","headerProfile":"Header_Resume_headerProfile__3sHRh","headerBack":"Header_Resume_headerBack__0BWOr","space":"Header_Resume_space__EHdih"};